import { render, staticRenderFns } from "./vue-openseadragon.vue?vue&type=template&id=62b59160&"
import script from "./vue-openseadragon.vue?vue&type=script&lang=js&"
export * from "./vue-openseadragon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports